export { default } from './RolesStore';



// WEBPACK FOOTER //
// ./src/stores/RolesStore/index.ts